function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "arrow-down_svg__a",
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "arrow-down_svg__b",
  d: "M0 0h16v16H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0,
  fill: "#FFF",
  xlinkHref: "#arrow-down_svg__a"
}), /*#__PURE__*/React.createElement("mask", {
  id: "arrow-down_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#arrow-down_svg__b"
})), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0,
  fill: "#FFF",
  xlinkHref: "#arrow-down_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10H4V8h6V2h2v8z",
  fill: "#BFBFBF",
  mask: "url(#arrow-down_svg__c)",
  transform: "rotate(45 8 6)"
}));

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgArrowDown;